const locationParams = ['top', 'left', 'right', 'bottom', 'start', 'end'] as const;

interface DrawerParams {
  component: Component;
  props?: Record<string, any>;
  location?: (typeof locationParams)[number];
  permanent?: boolean;
  temporary?: boolean;
}

export default defineStore('drawer', () => {
  const visibility = ref(false);
  const location = ref<(typeof locationParams)[number]>('left');
  const permanent = ref(false);
  const temporary = ref(false);
  const component = shallowRef<Component | null>(null);
  const componentProps = ref<Record<string, any>>({});

  const showDrawer = (params: DrawerParams) => {
    const {
      component: comp,
      props = {},
      location: loc = 'left',
      permanent: perm = false,
      temporary: temp = false,
    } = params;

    component.value = comp;
    componentProps.value = props;
    location.value = loc;
    permanent.value = perm;
    temporary.value = temp;
    visibility.value = true;
  };

  const closeDrawer = () => {
    visibility.value = false;
    setTimeout(() => {
      if (!visibility.value) {
        component.value = null;
        componentProps.value = {};
      }
    }, 300); // Delay to allow for closing animation
  };

  return {
    visibility,
    component,
    componentProps,
    location,
    permanent,
    temporary,
    showDrawer,
    closeDrawer,
  };
});
